import Vue from 'vue'

import Menu from './menu'

import {
  menuContentEditor,
  menuDesignEditor,
  additionalDataMock,
} from './menu.widget.mock'

import { registerWidget } from '../../common/functions/register-widget'

import { randomString } from '../../util'

function initBtnText(props) {
  return {
    loginBtnText: props.loginBtnText,
    signupBtnText: props.signupBtnText,
    accountBtnText: props.accountBtnText,
    signoutBtnText: props.signoutBtnText,
  }
}

function render(element, props, options) {
  Vue.component('ae-widget-menu', Menu)

  const wrapper = document.createElement('div')
  wrapper.id = randomString(15)

  element.innerHTML = ''
  element.appendChild(wrapper)

  new Vue({
    el: `#${wrapper.id}`,
    template:
    `<ae-widget-menu
      :iconCode="iconCode"
      :device="device"
      :myAccountPage="myAccountPage"
      :buttonsConfig="buttonsConfig"
    ></ae-widget-menu>`,
    data: function() {
      return {
        device: options.device,
        iconCode: props.iconCode || menuDesignEditor.iconCode,
        buttonsConfig: initBtnText(props),
        myAccountPage: props.myAccountPage,
      }
    }
  })
}

export function init({ container, props, ...additionalData }) {
  // Testing device on localhost
  if(location.hostname === 'localhost') {
    props = {
      ...menuContentEditor,
      ...menuDesignEditor,
    }

    additionalData = {
      ...additionalDataMock
    }
  }

  render(container, props, additionalData)
}

export function clean({ container }) {
  container.innerHTML = ''
}

registerWidget('menu', init, clean)
